export const SILENCE_OPTIONS = [
    { value: "0", label: "None (0s)" },
    { value: "0.25", label: "Short (0.25s)" },
    { value: "0.5", label: "Medium (0.5s)" },
    { value: "1", label: "Long (1s)" },
    { value: "2", label: "Very Long (2s)" },
];

export const CUSTOM_SILENCE_OPTION = "custom";
export const DEFAULT_SILENCE_AFTER = "0.5";

export function clampSilence(value: string | number): string | null {
    const stringValue = value === undefined || value === null ? "" : String(value);
    const numericValue = typeof value === "number" ? value : parseFloat(stringValue);
    if (!Number.isFinite(numericValue)) {
        return null;
    }
    const clampedValue = Math.min(Math.max(numericValue, 0), 9.99);
    return clampedValue.toString();
}
